const WORDS = [
  "Highly pigmented",
  "Zero fallout",
  "Liner to shadow",
  "No-glue formula",
  "Mink · 3D · Reusable",
  "WINK by Ace Vanity",
];

const Star = () => (
  <svg viewBox="0 0 24 24" className="mx-8 h-5 w-5 shrink-0 text-gold sm:mx-12" aria-hidden="true">
    <path d="M12 0 L14 10 L24 12 L14 14 L12 24 L10 14 L0 12 L10 10 Z" fill="currentColor" />
  </svg>
);

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {WORDS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="whitespace-nowrap font-display text-4xl font-light italic text-cream sm:text-6xl lg:text-7xl">{w}</span>
        <Star />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="relative overflow-hidden border-y border-gold/15 py-8 sm:py-12">
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
